import { createApp } from "vue";
import App from "./app.vue";

createApp(App).mount("#app");
